import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';
import { Observable } from 'rxjs';
import { DistributorBranch } from '../models/distributor-branch.model';

@Injectable({
  providedIn: 'root'
})
export class DistributorBranchService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }

  save(distributorBranch: DistributorBranch) {
    return this.http.post(this.configurations.apiAddress + "/api/DistributorBranch/save", distributorBranch);
  }

  search(searchText: string, distributorId) {
    let myParams = new HttpParams()
      .set('searchText', searchText == undefined ? "" : searchText)
      .set('distributorId', distributorId == undefined ? "0" : distributorId);
    return this.http.get(this.configurations.apiAddress + '/api/DistributorBranch/search', { params: myParams });
  }

  delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/DistributorBranch/delete/' + id);
  }

  getById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/DistributorBranch/getById/' + id);
  }

  downloadCsvTemplate(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/DistributorBranch/downloadCSVTemplate", { responseType: "blob" });

  }

  downloadErrorFile(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/DistributorBranch/downloadErrorFile", { responseType: "blob" });
  }

  uploadCsvTemplate(formData, distributorId) {
    return this.http.post(this.configurations.apiAddress + "/api/DistributorBranch/uploadCSVTemplate?distributorId=" + distributorId, formData);

  }
}
